const transacReducer = (transac = {} ,action) => {
    switch(action.type){
        case 'ADDTRANSAC':
            return transac = action.payload

        default:
            return transac;
    }

}

export default transacReducer;